'use client';
import styled, { css } from 'styled-components';
import get from 'lodash/get';

export const StyledPressLogos = styled.section`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: ${props =>
    props.theme.spacing(props.$verticalPadding, props.$horizontalPadding)};
`;

export const MobilePressLogoContainer = styled.div`
  width: 100%;
  ${props =>
    props.$isCarouselHide &&
    css`
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      align-items: flex-start;
      gap: ${props => props.theme.spacing(4)};
      padding: ${props => props.theme.spacing(0, 2)};
    `}
  @media ${props => props.theme.tablet} {
    display: none;
  }
`;

export const PressLogoContainer = styled.div`
  display: none;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: flex-start;
  @media ${props => props.theme.tablet} {
    display: flex;
  }
  @media ${props => props.theme.laptop} {
    flex-flow: row nowrap;
    align-items: unset;
    max-width: 1260px;
    margin: 0 auto;
  }
`;

export const HeadingContainer = styled.div`
  text-align: ${props => props.$position};
  padding: ${props => props.theme.spacing(1, 4)};
  color: ${props =>
    props.$fontColor && props.theme.colors.get(props.$fontColor)};
  margin: 0 auto;
  max-width: 870px;
  width: 100%;
`;

export const Heading = styled.h1`
  ${props => get(props.theme.typography, props.$typography.mobile)};
  @media ${props => props.theme.laptop} {
    ${props => get(props.theme.typography, props.$typography.desktop)};
  }
`;

export const LogoWrapper = styled.div`
  flex: 1 1 auto;
  flex-basis: 140px;
  margin: ${props => props.theme.spacing(9, 0, 6)};
  ${props =>
    props.$isCarouselHide &&
    css`
      flex: 0 1 calc(50% - ${props => props.theme.spacing(2)});
      max-width: 160px;
    `}
  @media ${props => props.theme.tablet} {
    flex: 1;
    flex-basis: 280px;
    min-width: 280px;
  }
  @media ${props => props.theme.laptop} {
    min-width: 300px;
  }
`;

export const StyledPressLogo = styled.div`
  max-width: 100%;
  text-align: center;
  ${props => !props.quote && 'align-self: center;'}
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  img {
    width: 100%;
  }
  @media ${props => props.theme.tablet} {
    width: 100%;
    img {
      width: auto;
      max-width: 200px;
    }
  }
`;

export const LogoContainer = styled.div`
  max-width: 100%;
  width: 170px;
  min-height: 60px;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
`;

export const Quote = styled.p`
  ${props => props.theme.typography.heading5}
  ${props => props.theme.fontFamily.base}
  color: ${props =>
    props.theme.colors.get(props.$fontColor, props.theme.colors.text.lightest)};
  margin-top: ${props => props.theme.spacing(4)};
  overflow-wrap: break-word;
`;
